import {WixAppRuntimeEnvironment} from "@wix/devzai-common-wix";

type AppType = 'DoppeAppViewer' | 'DoppeApp';

export class DoppeClientErrorsReportingService {

    async initialize (
        options: {
            environment: WixAppRuntimeEnvironment;
            appType: AppType;
            appVersion?: string;
        }
    ) {
        const {
            environment,
            appType,
            appVersion
        } = options;

        const sentry = await import('@sentry/browser');

        const DSNs : {[key in AppType]: string} = {
            DoppeApp: 'https://eadb81f1eec32e8ea949650940dc7d82@o37417.ingest.us.sentry.io/4506983403945984',
            DoppeAppViewer: 'https://34d0997c9f8984ac65486431b0301c91@o37417.ingest.us.sentry.io/4506983406305280',
        }

        sentry.init({
            dsn: DSNs[appType],
            environment: environment,
            attachStacktrace: true,
            release: `${appType}@${appVersion || 'unknown'}`,
            autoSessionTracking: false,
            ...(environment === 'local' && {
                integrations: [
                    sentry.breadcrumbsIntegration({
                        console: false,
                    }),
                ],
            }),
        });
    }
}
